import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { finalize, first, Observable } from 'rxjs';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { TalentinaService } from 'src/app/data/talentina.service';
import { ChatMessage } from 'src/app/shared/models/chat-message';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'talentina',
  templateUrl: './talentina.component.html',
  styleUrls: ['./talentina.component.scss'],
  standalone: false
})
export class TalentinaComponent implements OnInit, AfterViewInit {
  private formBuilder = inject(UntypedFormBuilder);
  private authService = inject(AuthService);
  private talentinaService = inject(TalentinaService);
  private cdr = inject(ChangeDetectorRef);
  private translate = inject(TranslateService);

  @ViewChild('chatmessages') private chatMessagesContainer!: ElementRef;
  formGroup: UntypedFormGroup;
  typing: boolean = false;
  thread: string = '';
  messages: ChatMessage[] = [];
  shouldAutoScroll: boolean = true;

  constructor() { }

  ngOnInit(): void {
    this.formGroup = this.buildFormGroup();
    this.talentinaService.talentinaAnswer.subscribe((answer) => {
      if (answer && answer.trim().length > 0) {
        this.messages.pop();
        this.messages.push({
          Date: new Date(),
          IsFromSender: false,
          Text: answer,
          IsLoading: false,
        });
        this.cdr.detectChanges(); 
        this.scrollIfNeeded();
      }
    });
  }

  ngAfterViewInit(): void {
    this.chatMessagesContainer.nativeElement.addEventListener('scroll', () => {
      const element = this.chatMessagesContainer.nativeElement;
      const threshold = 100;
      const position = element.scrollTop + element.clientHeight;
      const height = element.scrollHeight;

      this.shouldAutoScroll = position > height - threshold;
    });
  }

  get user(): Observable<any> {
    return this.authService.getUser();
  }

  get currentQuestion() {
    return this.formGroup.get('currentQuestion') as UntypedFormControl;
  }

  buildFormGroup(): UntypedFormGroup {
    return this.formBuilder.group({
      currentQuestion: [null],
    });
  }

  async send() {
    const question = this.currentQuestion.value;
    if (!question || question.trim() === '') {
      return;
    }

    this.typing = true;

    this.messages.push({
      Date: new Date(),
      IsFromSender: true,
      Text: question,
    });

    this.messages.push({
      Date: new Date(),
      IsFromSender: false,
      Text: '',
      IsLoading: true,
    });

    this.scrollIfNeeded();

    this.currentQuestion.disable();

    this.talentinaService
      .ask(question, this.thread)
      .pipe(
        first(),
        finalize(() => {
          this.currentQuestion.setValue('');
          this.currentQuestion.enable();
          this.typing = false;
        })
      )
      .subscribe({
        next: (answer: any) => {
          this.thread = answer.Thread;
        },
        error: (error: any) => {
          this.messages.pop();
          this.messages.push({
            Date: new Date(),
            IsFromSender: false,
            Text: this.translate.instant('TalentinaError'),
            IsLoading: false,
            IsError: true,
          });
          this.cdr.detectChanges();
          this.scrollIfNeeded();
        }
      });
  }

  private scrollIfNeeded() {
    if (this.shouldAutoScroll) {
      setTimeout(() => {
        const el = this.chatMessagesContainer.nativeElement;
        el.scrollTop = el.scrollHeight;
      });
    }
  }
}
